import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import Header from './Header';
import { OutlineIcons } from './Icons';

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // Navigation giống Backcom: Exchanges, Lịch sử, Tổng quan, Reward Hub, Cài đặt
  const menuItems = [
    { path: '/exchanges', label: t('nav.exchanges'), icon: 'rebate' },
    { path: '/history', label: t('nav.history'), icon: 'history' },
    { path: '/overview', label: t('nav.overview'), icon: 'overview' },
    { path: '/check-in', label: t('nav.rewardHub'), icon: 'rewardHub' },
    { path: '/profile', label: t('nav.settings'), icon: 'settings' },
  ];

  return (
    <div className="flex flex-col h-screen bg-[#0a0a0a] text-white overflow-hidden">
      <Header />
      <div className="flex-1 overflow-y-auto pb-[calc(68px+env(safe-area-inset-bottom)+1rem)] min-h-0">
        <Outlet />
      </div>
      <div className="fixed bottom-0 left-0 right-0 bg-[#0a0a0a] border-t border-gray-800/50 z-[1000]">
        <nav className="flex justify-around items-center h-[68px] px-2 pb-[env(safe-area-inset-bottom)]">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path || 
              (item.path === '/overview' && (location.pathname === '/' || location.pathname === '/overview')) ||
              (item.path === '/exchanges' && location.pathname.startsWith('/exchanges'));
            return (
              <button
                key={item.path}
                className="flex flex-col items-center justify-center gap-1 py-2 min-w-[64px] transition-all duration-200 active:scale-90"
                onClick={() => navigate(item.path)}
              >
                <div className={`w-10 h-10 flex items-center justify-center transition-all duration-200 ${
                  isActive ? 'scale-110' : ''
                }`}>
                  <span className={`transition-colors duration-200 ${
                    isActive ? 'text-primary' : 'text-gray-600'
                  }`}>
                    {OutlineIcons[item.icon as keyof typeof OutlineIcons]}
                  </span>
                </div>
                <span className={`text-[10px] font-medium transition-colors duration-200 ${
                  isActive ? 'text-primary' : 'text-gray-600'
                }`}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default Layout;
